import { Rig } from "@domain/CRM/rig";
import { DataAPI_Base, GetAPI_Base } from "../base";

class GetAPI_Rigs extends GetAPI_Base<Rig> {
	constructor() {
		super("rigs", Rig);
	}
}

export class RigsAPI extends DataAPI_Base<Rig> {
	get: GetAPI_Rigs;
	constructor() {
		super("rigs", Rig);
		this.get = new GetAPI_Rigs();
	}
}
